module.exports = __webpack_public_path__ + "static/media/main.c0baa237.png";